<script setup>
import { computed, toRefs } from "vue";
import { formatDateFullMonth } from "@/util/date";
import Banner from "./Banner.vue";

const props = defineProps({
  session: {
    type: Object,
    default() {
      return {};
    },
    required: true,
  },
});

const { session } = toRefs(props);

const sessionTravelDetails = computed(() => session.value?.session_travel_details);

const arrivalCity = computed(() => {
  if (!sessionTravelDetails.value) {
    return undefined;
  }
  return sessionTravelDetails.value[0]?.arrival_city?.city;
});

const arrivalCountry = computed(() => {
  if (!sessionTravelDetails.value) {
    return undefined;
  }
  return sessionTravelDetails.value[0]?.arrival_city?.country?.name;
});

const sessionLabel = computed(() => {
  const location = [arrivalCity.value, arrivalCountry.value].filter((item) => Boolean(item)).join(", ");
  const terms = session.value?.terms
    ?.map((term) => term.name)
    .filter((term) => Boolean(term))
    .join(", ");
  return [location, terms].filter((item) => Boolean(item)).join(" | ");
});

const sessionDates = computed(() => {
  const start = formatDateFullMonth(session.value?.academic_start_date);
  const end = formatDateFullMonth(session.value?.academic_end_date);
  return [start, end].filter((item) => Boolean(item)).join(" - ");
});
</script>

<template>
  <Banner v-if="session" class="md:mt-6">
    <template #title>
      <div class="flex text-2xl font-bold leading-[28px] text-university-primary">
        {{ session?.name }}
      </div>
    </template>
    <template #content>
      <div class="flex justify-between font-medium text-sm pt-2 text-university-primary">
        <label>{{ sessionLabel }}</label>
        <label>{{ sessionDates }}</label>
      </div>
    </template>
  </Banner>
</template>

